/**
 * roney
 * ajax util functions
 */
export Ajax from './ajax';
export RestAjax from './rest-ajax';



// WEBPACK FOOTER //
// src/common/ajax/index.js